import { FoundationProject } from '@models';

export interface ProjectResult {
  project: FoundationProject;
}
